import React from 'react';

const InsightsPage: React.FC = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Dream Insights</h1>
      <div className="bg-dark-card p-6 rounded-lg">
        <p className="text-gray-300">Your dream insights and analytics will appear here.</p>
      </div>
    </div>
  );
};

export default InsightsPage;
